import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function getEventSlugFromUrl(): string | undefined {
  const match = window.location.pathname.match(/^\/event\/([^/]+)/)
  return match?.[1]
}

export function eventPath(slug: string | undefined, suffix?: string): string {
  const base = slug ? `/event/${slug}` : ""
  return suffix ? `${base}/${suffix}` : base || "/"
}
